module.exports = __webpack_public_path__ + "img/icon-light-user.52fec835.svg";